import { render, staticRenderFns } from "./Exercises.vue?vue&type=template&id=067080c7&scoped=true&"
import script from "./Exercises.vue?vue&type=script&lang=js&"
export * from "./Exercises.vue?vue&type=script&lang=js&"
import style0 from "./Exercises.vue?vue&type=style&index=0&id=067080c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067080c7",
  null
  
)

export default component.exports